{
    "definitions": {
        "LightdashNodeConfig": {
            "allOf": [
                {
                    "$ref": "https://schemas.getdbt.com/dbt/manifest/v8.json#/definitions/NodeConfig"
                },
                {
                    "type": "object",
                    "properties": {
                        "meta": {
                            "oneOf": [
                                {
                                    "$ref": "https://schemas.lightdash.com/lightdash/metadata.json#/definitions/LightdashModelMetadata"
                                },
                                {
                                    "type": "null"
                                }
                            ]
                        }
                    }
                }
            ]
        },
        "LightdashColumnInfo": {
            "allOf": [
                {
                    "$ref": "https://schemas.getdbt.com/dbt/manifest/v8.json#/definitions/ColumnInfo"
                },
                {
                    "type": "object",
                    "properties": {
                        "name": {
                            "type": "string",
                            "not": { "enum": ["TABLE"] }
                        },
                        "meta": {
                            "oneOf": [
                                {
                                    "$ref": "https://schemas.lightdash.com/lightdash/metadata.json#/definitions/LightdashColumnMetadata"
                                },
                                {
                                    "type": "null"
                                }
                            ]
                        }
                    }
                }
            ]
        },
        "LightdashCompiledModelNode": {
            "allOf": [
                {
                    "$ref": "https://schemas.getdbt.com/dbt/manifest/v8.json#/definitions/ModelNode"
                },
                {
                    "type": "object",
                    "properties": {
                        "name": {
                            "type": "string",
                            "allOf": [
                                {
                                    "not": { "enum": ["lightdash", "ld", ""] }
                                },
                                {
                                    "pattern": "^[^.]*$"
                                }
                            ]
                        },
                        "meta": {
                            "oneOf": [
                                {
                                    "$ref": "https://schemas.lightdash.com/lightdash/metadata.json#/definitions/LightdashModelMetadata"
                                },
                                {
                                    "type": "null"
                                }
                            ]
                        },
                        "config": {
                            "$ref": "#/definitions/LightdashNodeConfig"
                        },
                        "columns": {
                            "type": "object",
                            "additionalProperties": {
                                "$ref": "#/definitions/LightdashColumnInfo"
                            },
                            "default": {}
                        }
                    }
                }
            ]
        }
    },
    "$schema": "http://json-schema.org/draft-07/schema#",
    "$id": "https://schemas.lightdash.com/lightdash/v8.json"
}
